import { styled } from "styled-components";

import { ReactComponent as AboutIcon } from "../../assets/icons/about.svg";
import { ReactComponent as WhatIDoIcon } from "../../assets/icons/whatido.svg";
import { ReactComponent as SkillsIcon } from "../../assets/icons/skills.svg";
import { ReactComponent as ExperienceIcon } from "../../assets/icons/experience.svg";
import { ReactComponent as WorksIcon } from "../../assets/icons/works.svg";
import { ReactComponent as Contact } from "../../assets/icons/contact.svg";

const Navigation = () => {
  return (
    <StyledNav>
      <ul>
        <li>
          <a href="#about">
            <AboutIcon />
          </a>
        </li>
        <li>
          <a href="#whatido">
            <WhatIDoIcon />
          </a>
        </li>
        <li>
          <a href="#skills">
            <SkillsIcon />
          </a>
        </li>
        <li>
          <a href="#experience">
            <ExperienceIcon />
          </a>
        </li>
        <li>
          <a href="#works">
            <WorksIcon />
          </a>
        </li>
        <li>
          <a href="#contact">
            <Contact />
          </a>
        </li>
      </ul>
    </StyledNav>
  );
};

const StyledNav = styled.nav`
  position: absolute;
  bottom: 20px;
  padding: 5px;

  ul {
    display: flex;
    flex-flow: wrap row;
    gap: 18px;
    list-style: none;
    margin: 0;
    padding: 0;

    li {
      opacity: 0.4;
      &:hover {
        opacity: 1;
      }

      svg {
        width: 25px;
        height: 28px;
      }
    }
  }

  @media (min-width: 1100px) {
    position: absolute;
    right: 30px;
    bottom: 50%;
    transform: translateY(50%);

    ul {
      display: flex;
      flex-direction: column;
      gap: 10px;

      li {
        svg {
          width: 30px;
          height: 33px;
        }
      }
    }
  }
  @media (max-height: 550px) {
    position: absolute;
    right: 30px;
    bottom: 50%;
    transform: translateY(50%);

    ul {
      display: flex;
      flex-direction: column;
      gap: 10px;

      li {
        svg {
          width: 25px;
          height: 28px;
        }
      }
    }
  }
`;

export default Navigation;
